import { RotateCcw } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface RereadBadgeProps {
  count: number;
  className?: string;
}

export function RereadBadge({ count, className }: RereadBadgeProps) {
  if (count === 0) return null;

  const label = count === 1 ? '1 reread' : `${count} rereads`;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge 
            variant="secondary" 
            className={`gap-1 cursor-default ${className || ''}`}
          >
            <RotateCcw className="h-3 w-3" />
            {count}
          </Badge>
        </TooltipTrigger>
        <TooltipContent>
          <p>{label}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
